module.exports = __webpack_public_path__ + "img/pending-tasks.5f3b6b61.svg";